export const MASTER_ITEM = '/items'
export const MASTER_VARIETY = '/varieties'
export const MASTER_FLOWER_TYPE = '/flower_types'
export const MASTER_PACKING = '/packings'
export const LOGIN_USERS = '/login_users'
export const MASTER_ROLE = '/roles'
export const MEMBERS = '/members'
export const MASTER_MEMBER = '/members'

export const MASTER_GRADE = '/grades'
export const MASTER_RANK = '/ranks'
export const MASTER_COLOR = '/colors'
export const MASTER_UNIT = '/units'
export const MASTER_BUYER = '/buyers'
export const MASTER_SETTING = '/settings'
export const MASTER_SHIPPER = '/shippers'
export const MASTER_PREFECTURE = '/prefectures'
export const MASTER_SUPPLIER = '/suppliers'
export const MASTER_PARTNER = '/partners'
export const UPLOADED_FILES = '/uploaded-files'
export const MASTER_CLOSING_TYPE = '/closing_types'
export const MASTER_PAYMENT_SITE = '/payment_sites'
export const MASTER_CALENDAR = '/calendars'
export const MAIL_DELIVERY = '/mail-delivery'
export const MASTER_MAIL_TYPE = '/mail-types'
export const MASTER_MAIL_STATUS = '/mail-statuses'
